import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const PasswordComplexityRequirementStyle = makeStyles()((theme: Theme) => ({
  securePasswordContainer: {
    backgroundColor: '#F5F5F5',
    marginBottom: theme.spacing(1.25),
    borderRadius: '5px',
    padding: '0 20px',
    '& .MuiSvgIcon-root': {
      marginTop: '6px',
      fill: '#00AE4D',
    },
    '& p': {
      fontSize: '14px',
    },
  },
  passwordComplexity: {
    display: 'flex',
    flexFlow: 'row wrap',
    listStyle: 'none',
    margin: theme.spacing(-1.25, 0, 1.25),
    padding: 0,
    '& li': {
      fontSize: '14px',
      lineHeight: '1.5',
      width: '192px',
      '&:before': {
        content: '"\\2022"',
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        display: 'inline-block',
        fontSize: '16px',
        lineHeight: 1,
        left: '-1.5px',
        position: 'relative',
        margin: theme.spacing(0, 0.5, 0, 1),
      },
      '&.active': {
        '&:before': {
          content: '""',
        },
        '& span': {
          marginLeft: '-11.5px',
          paddingRight: '5.5px',
        },
      },
      '& .MuiSvgIcon-root': {
        fontSize: '0.95rem',
        fill: '#00ae4d',
        position: 'relative',
        top: '3px',
        left: '3px',
      },
    },
  },
}))

export default PasswordComplexityRequirementStyle
